import { useState } from 'react';
import { Box, Skeleton, styled, Typography } from '@mui/material';
import {
  BORDER_COLOR,
  GRADIENT_BACKGROUND,
  pulseAnimation,
} from 'components/AI/AIStyles';
import { useGetApiV5FilesPendingReview } from 'api/v5/files/files';
import { ReviewModal } from './components';

const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: theme.spacing(4),
  background: GRADIENT_BACKGROUND,
  border: '1px solid',
  borderColor: BORDER_COLOR,
  borderRadius: theme.shape.borderRadius,
  cursor: 'pointer',
  '&:hover': {
    animation: `${pulseAnimation} 2s 1`,
    boxShadow: '0px 5px 20px rgba(0, 0, 0, 0.1)',
  },
}));

const StyledTypography = styled(Typography)({
  fontWeight: 'bold',
  color: 'rgb(0, 175, 204)',
  //   color: 'rgb(236, 42, 171)',
});

export interface AIFileReviewProps {
  /**
   * Old ugly dependency to refresh the list in parent component
   */
  component: any;
}

export const AIFileReview: React.FC<AIFileReviewProps> = ({ component }) => {
  const [isPreviewModalVisible, setIsPreviewModalVisible] = useState(false);
  const { data: filesToReview, isLoading } = useGetApiV5FilesPendingReview();

  return (
    <>
      <Container onClick={() => setIsPreviewModalVisible(true)}>
        {isLoading && <Skeleton variant="text" width={50} height={67.5} />}
        {!isLoading && (
          <StyledTypography variant="h2">
            {filesToReview?.count || 0}
          </StyledTypography>
        )}
        <Typography>files need review</Typography>
      </Container>
      {isPreviewModalVisible && (
        <ReviewModal
          onClose={() => setIsPreviewModalVisible(false)}
          component={component}
        />
      )}
    </>
  );
};
